<template>
  <div
    class="file-container-fail flex flex-col justify-center items-center w-full h-full"
  >
    <feather-icon
      class="file-read-error-icon"
      icon="AlertCircleIcon"
    ></feather-icon>
    <div class="file-read-error-message">
      {{ fileReadErrorMessage }}
    </div>
  </div>
</template>

<script>
export default {
  name: "OperationReportShowBodyFormItemFileReadErrorMessage",

  props: {
    fileReadErrorMessage: {
      type: String,
      default: "",
    },
  },
};
</script>
